module.exports = __webpack_public_path__ + "static/media/icon-react.08021eab.svg";